/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpendingactivationtitle4Inputs */



/**
* | output |
* | --- |
* | "Subscription not activated yet" |
*
* @param {Subscriptionalertpendingactivationtitle4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpendingactivationtitle4 = /** @type {((inputs?: Subscriptionalertpendingactivationtitle4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpendingactivationtitle4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Subscription not activated yet")
	if (locale === "es") return /** @type {LocalizedString} */ ("La suscripción aún no está activada")
	return /** @type {LocalizedString} */ ("Подписка ещё не активирована")
});
export { subscriptionalertpendingactivationtitle4 as "subscriptionAlertPendingActivationTitle" }